
import styled from 'styled-components';

export const Campaignfooter = styled.div`
  position: fixed;
  position: ${({ position }) => position};
  bottom: 0;
  left: 0;
  width: 100%;
  height: calc(100vw * (56 / 375));
  z-index: 200;
`;
export const DummySpacer = styled.div`
  height: calc(100vw * (56 / 375));
`;
export const FooterTxt = styled.button`
  width: 100%;
  font-size: calc(100vw * (18 / 375));
  font-weight: bold;
  line-height: calc(100vw * (56 / 375));
  letter-spacing: calc(100vw * (0.25 / 375));
  text-align: center;
  color: #4e4e4e;
  color: ${(props) => props.color};
  background-color: #ffcf19;
  background-color: ${(props) => props.bgcolor};
`;
export const FooterTxtCancle = styled(FooterTxt)`
  color: #fff;
  background-color: #4e4e4e;
`;
